import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { post } from "../../lib/sessionClient";
import { clearLocalStorageSession } from "../../lib/authUtils";

const usePostData = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState("");
  const [successResponse, setSuccessResponse] = useState(null);

  const executePost = async (
    sendData,
    apiUrl,
    updateStateOnResponse,
  ) => {
    setLoading(true);
    setFormError("");
    try {
      const response = await post(apiUrl, sendData);
      console.log(successResponse, "successResponse")
      setSuccessResponse(response.data || "No data available");
      updateStateOnResponse?.(response.data);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        clearLocalStorageSession();
        navigate("/login");
      } else {
        setFormError(error.response?.data?.message || error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    executePost,
    loading,
    formError,
    setFormError,
    successResponse,
    setSuccessResponse
  };
};

export default usePostData;
